module.exports = __webpack_public_path__ + "img/pa.2a0d8968.png";